import { queryOptions } from '@tanstack/react-query';
import { orderNoteApi } from './order-note-api';

export const orderNoteKeys = {
  all: ['order-notes'] as const,
  list: (orderId: string | number) => [...orderNoteKeys.all, String(orderId)] as const,
};

export const orderNoteQueries = {
  /** Lazy: only fetched when `enabled` (the notes dialog is open). */
  list: (orderId: string | number, enabled: boolean) =>
    queryOptions({
      queryKey: orderNoteKeys.list(orderId),
      queryFn: () => orderNoteApi.list(orderId),
      enabled,
    }),
};
